<script>
  /**
   * Specify the pictogram title.
   * @type {string}
   */
  export let title = undefined;

  $: labelled =  $$props["aria-label"] || $$props["aria-labelledby"] || $$props["title"];
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0  ? true : undefined,
  };
</script>

<svg
  preserveAspectRatio="xMidYMid meet"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  width="64"
  height="64"
  fill="currentColor"
  {title}
  {...attributes}
  {...$$restProps}>
  <path d="M16,31.36C7.53,31.36,0.64,24.47,0.64,16S7.53,0.64,16,0.64S31.36,7.53,31.36,16	S24.47,31.36,16,31.36z M15.385,30.627c0.204,0.009,0.409,0.013,0.615,0.013c4.741,0,8.963-2.265,11.64-5.77V12.008h0.721v11.831	c1.442-2.268,2.279-4.957,2.279-7.839c0-1.999-0.402-3.904-1.13-5.641L18.363,3.924l0.36-0.624l10.249,5.917	c-2.174-4.141-6.273-7.119-11.101-7.738L6.723,7.916l-0.36-0.624l10.252-5.919C16.412,1.364,16.206,1.36,16,1.36	c-4.741,0-8.963,2.266-11.64,5.771v12.862H3.64V8.161C2.197,10.429,1.36,13.119,1.36,16c0,1.998,0.402,3.903,1.13,5.641	l11.147,6.436l-0.36,0.623L3.028,22.782c2.174,4.142,6.273,7.12,11.101,7.739l11.148-6.437l0.359,0.623L15.385,30.627z M11.352,23.664c-0.062,0-0.124-0.017-0.18-0.049c-0.118-0.067-0.188-0.196-0.18-0.333l0.199-3.35	c0.003-0.056,0.02-0.11,0.048-0.158l6.5-11.258c0.048-0.083,0.126-0.143,0.219-0.167c0.09-0.025,0.189-0.012,0.272,0.036l2.598,1.5	c0.173,0.099,0.231,0.319,0.132,0.492l-6.5,11.257c-0.028,0.049-0.066,0.09-0.113,0.12l-2.797,1.85	C11.49,23.644,11.421,23.664,11.352,23.664z M11.905,20.061l-0.151,2.546l2.125-1.406l6.277-10.872l-1.974-1.14L11.905,20.061z"></path>
</svg>